/*
  backend integration with DE
*/
import axios from 'axios';
import queryString from 'query-string';


import { hasEmployerToken } from '../../util/auth/token';
import * as AuthActions from './authActions';
import * as PrivilegeActions from './privilegeActions';

import { isEnvironmentProduction } from '../../env/env';

const AUTH_LOGIN_BASE_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }`;
const AUTH_BASE_URL_DE = `${ process.env.REACT_APP_MS_AUTHENTICATION_DE_PUBLIC }token/create`;
const AUTH_BASE_URL_PARTNER = `${ process.env.REACT_APP_MS_AUTHENTICATION_PARTNER_PUBLIC }login`;

export const fetchUserDetails = () => {
   return axios.get(`${ AUTH_LOGIN_BASE_URL }/api/user/getDetails`);
};

export const fetchPrivileges = (owner) => {
   return axios.get(`${ AUTH_LOGIN_BASE_URL }/api/user/pageConfigs${ (owner && owner.id ? `?organizationId=${ owner.id }` : '') }`);
};

async function setUserProperties(dispatch, userDetails, privileges) {
   await dispatch(AuthActions.userDetailsSuccess(userDetails));
   await dispatch(PrivilegeActions.privilegeFetchSuccess(privileges));
}

export const getLoggedInUserDetails = () => {
   return (dispatch) => {
      if (hasEmployerToken()) {
         dispatch(AuthActions.globalGetUserDetailsLoading());
         Promise.all([
            fetchUserDetails(),
            fetchPrivileges(),
         ])
            .then((values) => {
               if (values && values.length === 2) {
                  const userDetails = values[0].data.user;
                  const { privileges } = values[1].data;
                  setUserProperties(dispatch, userDetails, privileges);
               }
            })
            .catch((error) => {
               dispatch(AuthActions.globalGetUserDetailsError());
            });
      } else {
         dispatch(AuthActions.setAuthGlobalIsLoading(false));
      }
   };
};

/*

  method to log user in
  takes in params object with username, password and rememberMe
  the post format has to be maintained
  Hacked a way into existing DE auth login
  to find if the user login was success or failure

*/
//  this method is for traditional /auth/login
// export const logInUser = ( params, callBack )=>{
//   return ( dispatch ) =>  {
//     dispatch( AuthActions.loginUserPending() );
//     const formPostData = Object.entries(params)
//     .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
//     .join('&');
//     axios({
//       method : "POST",
//       url : AUTH_LOGIN_BASE_URL + "/auth/login",
//       data : formPostData,
//       config : {
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' ,
//           "Access-Control-Allow-Origin": "*"
//         }
//       }
//     })
//       .then( response => {
//         if( response.data && typeof response.data === "string" && response.data.indexOf("Please check the email and password you entered") > -1 ){
//           console.log("dispatching error");
//           dispatch( AuthActions.loginUserError("Please check the email and password you entered.") );
//         } else {
//           console.log("dispatching success");
//           //dispatch( getLoggedInUserDetails() );
//           dispatch( AuthActions.loginUserSuccess() );
//         }
//       })
//       .catch((error)=>{
//         console.log( error );
//         dispatch( AuthActions.loginUserError(error) );
//       })
//       .finally( function(){

//       })
//   }
// }
// this method is for login using JWT
//


export const logInUserToken = (params, callBack) => {
   return (dispatch) => {
      dispatch(AuthActions.loginUserPending());
      axios({
         method: 'POST',
         url: `${ AUTH_BASE_URL_DE }`,
         data: queryString.stringify(params),
         config: {
            headers: {
               'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
         },
      })
         .then((response) => {
            // console.log('LOGIN RESPONSE >>>> ', response, response.data);


            if (response.data && response.data.token) {
               dispatch(AuthActions.loginUserSuccess(response.data));
               dispatch(getLoggedInUserDetails());
            } else {
               dispatch(AuthActions.loginUserError('Username and email combination doesnt match.'));
            }
         })
         .catch((error) => {
            dispatch(AuthActions.loginUserError('Username and email combination doesnt match.'));
         })
         .finally(() => { });
   };
};

export const logInUserTokenAndCookie = (params, callBack) => {
   return (dispatch) => {
      dispatch(AuthActions.loginUserPending());
      axios({
         method: 'POST',
         url: `${ AUTH_LOGIN_BASE_URL }/auth/apilogin`,
         data: params,
         config: {
            headers: {
               'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
               'Access-Control-Allow-Origin': '*',
            },
         },
      })
         .then((response) => {
            if (response.data && response.data.token) {
               dispatch(AuthActions.loginUserSuccess(response.data));
               dispatch(getLoggedInUserDetails());
            } else {
               dispatch(AuthActions.loginUserError('Username and email combination doesnt match.'));
            }
         })
         .catch((error) => {
            dispatch(AuthActions.loginUserError('Username and email combination doesnt match.'));
         })
         .finally(() => { });
   };
};

export const logInUser = (params, callBack) => {
   // NEED TO FULLY TEST AOE BEFORE ABLE TO PUSH TO PRODUCTION !!!!!!!!!!!!!
   // DO NOT REMOVE UNLESS READY TO RELEASE TOKEN ONLY AOE TO PROD!!!!
   console.log(`PERFORM ${ process.env.REACT_APP_UPWARD_ENV } LOGIN <<<<`);

   // if (!isEnvironmentProduction()) {
   return logInUserToken(params, callBack);
   // }

   // return logInUserTokenAndCookie(params, callBack);
};

/*
  method to log user out
*/
export const logOutUser = (callBack) => {
   return (dispatch) => {
      if (hasEmployerToken()) {
         axios.post(`${ AUTH_LOGIN_BASE_URL }/logout`)
            .then((res) => {
               document.cookie = 'EMPL=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
               document.cookie = 'JSESSIONID=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/ectools;';

               dispatch(AuthActions.logoutUserSuccess('Successfully logged out.'));
               if (callBack) {
                  callBack();
               }
            })
            .catch((error) => {
               dispatch(AuthActions.loginUserError(error));
            })
            .finally(() => { });
      } else {
         dispatch(AuthActions.logoutUserSuccess('Successfully logged out.'));
      }

      dispatch(AuthActions.logoutUserSuccess('Successfully logged out.'));

      setTimeout(() => {
         window.location.reload();
      }, 3000);
   };
};


